<template>
    <div>
        <div class="pageTop">
            <div class='left'>                
                <p class='title'>{{baseName}}</p>                
            </div>
            <div class='right' style="margin-top:5px">
                <van-button color='#1588d0' icon="plus" type="info"  size="mini" @click='addRotationPopup'></van-button>
                <van-icon name="apps-o" color='#0076bf' size='22' @click="rListShow" style="vertical-align: middle;margin-left:15px"/>                
            </div>
        </div>
        <div  ref='pageMain'  style="overflow:auto;padding:0 5px">
            <van-panel v-for="(item,index) in rotationList" :key="index" style="margin-bottom:10px" >
                <div slot="header" class="van-cell van-panel__header">
                    <div class="van-cell__title">
                        <span>{{item.name}}</span>                        
                    </div>
                    <div class='van-cell__value van-panel__header-value'>
                        <!-- <van-switch  v-model="item.valid" :active-value=1 :inactive-value=0  size="24px" style="vertical-align: middle"/> -->
                        <van-icon name="setting-o" size="18px" color='#666' @click="upRotationPopup(item,index)" style="vertical-align: middle;margin-left:15px"/>
                        <!-- <span :style="{color:item.is_online == 1 ? '#07c160' : '#ee0a24'}">{{item.is_online == 3 ? '' : (item.is_online == 1 ? '在线' : '离线')}}</span> -->
                    </div>
                </div>
                <div>
                    <van-grid :column-num="4">
                        <van-grid-item>
                            <p style="font-size:10px;text-align: center;height:20px">是否重复</p><br/>                            
                            <span style="color:#047cff;line-height:20px;font-size:14px">{{item.repeate== 1 ? "重复":'一次'}}</span>
                        </van-grid-item>
                        <van-grid-item>
                            <p style="font-size:10px;text-align: center;height:20px">循环</p><br/>                            
                            <span style="color:#53db6a;line-height:20px;font-size:14px">{{item.loop_state== 1 ? "正在循环":'否'}}</span>
                        </van-grid-item>
                        <van-grid-item>
                            <p style="font-size:10px;text-align: center;height:20px">时长</p><br/>                            
                            <span style="color:#f1b158;line-height:20px;font-size:14px">{{item.duration}} 分钟</span>
                        </van-grid-item>
                        <van-grid-item>
                            <p style="font-size:10px;text-align: center;height:20px">每日启动时间</p><br/>                            
                            <span style="color:#947aeb;line-height:20px;font-size:14px">{{item.start_time.substr(10)}}</span>
                        </van-grid-item>
                    </van-grid>
                </div>
                <div slot='default' style="padding:5px;display:flex;justify-content: flex-end">
                    <van-button  :type="!item.run_state ? 'info':'danger'" :disabled='item.loadState==1 ? true:false' :loading='item.loadState==1 ? true:false' @click="openCloseRotation(item,index)"   plain hairline size="small" >
                        <span v-if ='!item.run_state'>立即启动</span>
                        <span v-else>关闭</span>
                    </van-button>
                    <van-button  type="danger" plain hairline size="small" style="margin-left:10px" @click='delok(item)'>删除</van-button>
                </div>
            </van-panel>
            <van-divider  :style="{padding: '0 16px' }">
                    没有更多啦
                </van-divider>
        </div>


        <!-- 新增 -->
        <van-popup v-model="isShowaddRotationPopup"  position="right"  get-container="body" :style="{ height: '100%',width:'100%' }" >
            <van-nav-bar    left-text="返回" @click-left="isShowaddRotationPopup = false"    left-arrow>
                <van-icon name="success" slot="right"  @click="addNewRotation"/>
            </van-nav-bar>
            <div  style="position:absolute;top:46px;bottom:0;left:0;right:0;overflow:auto;">
                <van-cell-group title='新增轮灌组' >
                    <van-field label="名称" v-model="addRotaInfo.name" placeholder="请输入名称" />
                    <van-field label="间隔时间(秒)" v-model="addRotaInfo.Interval" type='number' placeholder="请输入间隔时间" />
                    <van-field label="时长(分钟)" v-model="addRotaInfo.Duration" type='number' placeholder="请输入时长" />
                     <van-cell title="每周计划" :value="addRotaInfo.WeekPlan.toString()" @click='showWeekPlan = true' is-link/>
                     <van-cell title="运行状态" :value="addRotaInfo.reploopList.toString()" @click='showloopState = true' is-link/>
                     <van-cell title="每日开启时间" :value="addRotaInfo.StartTime.toString()" @click='showStartTime = true' is-link/>
                     <van-cell title="定时功能设置" :value="addRotaInfo.valid =='0' ? '关闭':'开启'" @click='showvalid = true' is-link/>
                     <van-cell title="选择水泵" :value="addRotaInfo.pump.name" @click='showChangePump = true' is-link/>
                     <!-- <van-cell title="选择施肥泵" :value="addRotaInfo.fertilizer.name" @click='showChangeFerti = true' is-link/> -->
                     <van-cell title="选择阀门" @click='showChangeValve = true' is-link/>
                     <van-collapse v-model="addActiveNames">                        
                         <van-collapse-item :title="`轮灌组(${addRotaInfo.rotationList.length}组)`" name="1" accordion>
                            <van-panel style="background:#f8f8f8;margin-bottom:15px" v-for="(item,index) in addRotaInfo.rotationList" :key="index" >
                                <div slot="header" class="van-cell van-panel__header" style="background-color:#f8f8f8">
                                    <div class="van-cell__title">
                                        <span>轮灌组{{index+1}}</span>                        
                                    </div>                    
                                    <div class='van-cell__value van-panel__header-value'>
                                        <van-icon name="cross" @click="addDelValveList(index)"/>
                                    </div>
                                </div>
                                <div style="padding-left:15px">{{valveNameList[index].toString()}}</div>
                            </van-panel>
                         </van-collapse-item>
                     </van-collapse>
                     <!-- <van-cell title="水泵组" :value="'共'+addRotaInfo.rotationList.length+'组'" is-link />                    -->
                </van-cell-group>
            </div>
        </van-popup>

        <!-- 每周计划 -->
        <van-popup v-model="showWeekPlan"  get-container="body">            
            <van-checkbox-group v-model="addRotaInfo.WeekPlan" :style="{ width: '250px',marginTop:'50px' }">
                <van-cell-group>
                    <van-cell v-for="(item, index) in weekList" clickable :key="index" :title="item.value" @click="weekToggle(index)">
                        <van-checkbox :name="item.key" ref="weekCheckboxes" slot="right-icon" />
                    </van-cell>
                </van-cell-group>
            </van-checkbox-group>
        </van-popup>
        <!-- 运行状态 -->
        <van-popup v-model="showloopState" closeable get-container="body">
            <van-checkbox-group v-model="addRotaInfo.reploopList" :style="{ width: '250px',marginTop:'50px' }">
                <van-cell-group>
                    <van-cell v-for="(item, index) in stateList"  :key="index" :title="item.value" @click="stateToggle(index)">
                        <van-checkbox :name="item.key" ref="stateCheckboxes" slot="right-icon" />
                    </van-cell>
                </van-cell-group>
            </van-checkbox-group>
        </van-popup>
        <!-- 开始时间 -->
        <van-popup v-model="showStartTime" get-container="body" :style="{ width: '150px'}">
            <van-datetime-picker @confirm='(value)=>{addRotaInfo.StartTime = value;showStartTime = false}' @cancel='showStartTime = false'     type="time" />        
        </van-popup>
        <!-- 定时功能 -->
         <van-popup v-model="showvalid"  get-container="body" :style="{ width: '150px'}">
            <van-radio-group v-model="addRotaInfo.valid">
                <van-cell-group>
                    <van-cell title="开启" clickable @click="addRotaInfo.valid = '1';showvalid=false">
                    <van-radio slot="right-icon" name='1' />
                    </van-cell>
                    <van-cell title="关闭" clickable @click="addRotaInfo.valid = '0';showvalid=false">
                    <van-radio slot="right-icon" name='0' />
                    </van-cell>
                </van-cell-group>
            </van-radio-group>
        </van-popup>
        <!-- 选择水泵 -->
         <van-popup v-model="showChangePump"  get-container="body" :style="{ width: '150px'}">
            <van-radio-group v-model="addRotaInfo.pump.key">
                <van-cell-group>
                    <van-cell v-show="pumpList.length>0 ?true:false " v-for="(item,index) in pumpList" :key='index' :title="item.name" clickable @click="changeAddPump(item)">
                        <van-radio slot="right-icon" :name='item.pc_id' />
                    </van-cell>
                    <van-cell v-show="!pumpList.length>0 ?true:false ">暂无水泵</van-cell>
                </van-cell-group>
            </van-radio-group>
        </van-popup>
        <!-- 选择施肥泵 -->
         <van-popup v-model="showChangeFerti"  get-container="body" :style="{ width: '150px'}">
            <van-radio-group v-model="addRotaInfo.fertilizer.key">
                <van-cell-group>
                    <van-cell v-show="fertilizerList.length>0 ?true:false " v-for="(item,index) in fertilizerList" :key='index' :title="item.name" clickable @click="changeAddFerti(item)">
                        <van-radio slot="right-icon" :name='item.pc_id' />
                    </van-cell>
                    <van-cell v-show="!fertilizerList.length>0 ?true:false ">暂无施肥泵</van-cell>
                </van-cell-group>
            </van-radio-group>
        </van-popup>
        <!-- 选择阀门 -->
         <van-popup v-model="showChangeValve"   get-container="body" :style="{ width: '80%',height:'80%'}">
             <van-sticky :offset-top="0" >
            <van-cell title=" " v-show='valveArr.length>0 ? true :false'>
                <van-icon slot="icon" size='16px' name="cross" style="line-height: inherit;" @click='showChangeValve = false;transitList = []' />
                <van-icon slot="right-icon" size='16px' name="success" style="line-height: inherit;" @click='saveValveList' />
            </van-cell>
             </van-sticky>
             <div style="position:absolute;top:40px;bottom:0;overflow:auto;width:100%">
                <van-checkbox-group v-model="transitList"  >                                
                    <van-cell-group>
                        <van-cell v-show='valveArr.length>0 ? true :false' v-for="(item, index) in valveArr" clickable :key="index" :title="item.name" @click="valveToggle(index)">
                            <van-checkbox :name="item.pc_id" ref="valveCheckboxes" slot="right-icon" />
                        </van-cell>
                        <van-cell v-show='!valveArr.length>0 ? true :false'>暂无阀门</van-cell>
                    </van-cell-group>
                </van-checkbox-group>
             </div>            
        </van-popup>


        <!-- 修改 -->
        <van-popup v-model="isShowupRotationPopup"  position="right"  get-container="body" :style="{ height: '100%',width:'100%' }" >
            <van-nav-bar    left-text="返回" @click-left="isShowupRotationPopup = false"    left-arrow>
                <van-icon name="success" slot="right"  @click="upRotation"/>
            </van-nav-bar>
            <div  style="position:absolute;top:46px;bottom:0;left:0;right:0;overflow:auto;">
                <van-cell-group title='修改轮灌组' >
                    <van-field label="名称" v-model="upRotaInfo.name" placeholder="请输入名称" />
                    <van-field label="间隔时间(秒)" v-model="upRotaInfo.Interval" type='number' placeholder="请输入间隔时间" />
                    <van-field label="时长(分钟)" v-model="upRotaInfo.Duration" type='number' placeholder="请输入时长" />                   
                     <van-cell title="每周计划" :value="upRotaInfo.WeekPlan.toString()" @click='showUpWeekPlan = true' is-link/>
                     <van-cell title="运行状态" :value="upRotaInfo.reploopList.toString()" @click='showUploopState = true' is-link/>
                     <van-cell title="每日开启时间" :value="upRotaInfo.StartTime.toString()" @click='showUpStartTime = true' is-link/>
                     <van-cell title="定时功能设置" :value="upRotaInfo.valid =='0' ? '关闭':'开启'" @click='showUpvalid = true' is-link/>
                     <van-cell title="选择水泵" :value="upRotaInfo.pump.name" @click='showUpChangePump = true' is-link/>
                     <!-- <van-cell title="选择施肥泵" :value="upRotaInfo.fertilizer.name" @click='showChangeFerti = true' is-link/> -->
                     <van-cell title="选择阀门" @click='showUpChangeValve = true' is-link/>
                     <van-collapse v-model="upActiveNames">                        
                         <van-collapse-item :title="`轮灌组(${upRotaInfo.rotationList.length}组)`" name="1" accordion>
                            <van-panel style="background:#f8f8f8;margin-bottom:15px" v-for="(item,index) in upRotaInfo.rotationList" :key="index" >
                                <div slot="header" class="van-cell van-panel__header" style="background-color:#f8f8f8">
                                    <div class="van-cell__title">
                                        <span>轮灌组{{index+1}}</span>                        
                                    </div>                    
                                    <div class='van-cell__value van-panel__header-value'>
                                        <van-icon name="cross" @click="upDelValveList(index)"/>
                                    </div>
                                </div>
                                <div style="padding-left:15px">{{upValveNameList[index].toString()}}</div>
                            </van-panel>
                         </van-collapse-item>
                     </van-collapse>                     
                </van-cell-group>
            </div>
        </van-popup>

        <!-- 每周计划 -->
        <van-popup v-model="showUpWeekPlan"  get-container="body">           
            <van-checkbox-group v-model="upRotaInfo.WeekPlan" :style="{ width: '250px',marginTop:'50px' }">
                <van-cell-group>
                    <van-cell v-for="(item, index) in weekList" clickable :key="index" :title="item.value" @click="upweekToggle(index)">
                        <van-checkbox :name="item.key" ref="upWeekCheckboxes" slot="right-icon" />
                    </van-cell>
                </van-cell-group>
            </van-checkbox-group>
        </van-popup>
        <!-- 运行状态 -->
        <van-popup v-model="showUploopState" closeable get-container="body">
            <van-checkbox-group v-model="upRotaInfo.reploopList" :style="{ width: '250px',marginTop:'50px' }">
                <van-cell-group>
                    <van-cell v-for="(item, index) in stateList"  :key="index" :title="item.value" @click="upstateToggle(index)">
                        <van-checkbox :name="item.key" ref="stateUpCheckboxes" slot="right-icon" />
                    </van-cell>
                </van-cell-group>
            </van-checkbox-group>
        </van-popup>
        <!-- 开始时间 -->
        <van-popup v-model="showUpStartTime" get-container="body" :style="{ width: '150px'}">
            <van-datetime-picker @confirm='(value)=>{upRotaInfo.StartTime = value;showUpStartTime = false}' @cancel='showUpStartTime = false'     type="time" />        
        </van-popup>
        <!-- 定时功能 -->
         <van-popup v-model="showUpvalid"  get-container="body" :style="{ width: '150px'}">            
            <van-radio-group v-model="upRotaInfo.valid">
                <van-cell-group>
                    <van-cell title="开启" clickable @click="upRotaInfo.valid = '1';showUpvalid=false">
                    <van-radio slot="right-icon" name='1' />
                    </van-cell>
                    <van-cell title="关闭" clickable @click="upRotaInfo.valid = '0';showUpvalid=false">
                    <van-radio slot="right-icon" name='0' />
                    </van-cell>
                </van-cell-group>
            </van-radio-group>
        </van-popup>
        <!-- 选择水泵 -->
         <van-popup v-model="showUpChangePump"  get-container="body" :style="{ width: '150px'}">            
            <van-radio-group v-model="upRotaInfo.pump.key">
                <van-cell-group>
                    <van-cell v-show="pumpList.length>0 ?true:false " v-for="(item,index) in pumpList" :key='index' :title="item.name" clickable @click="changeUpPump(item)">
                        <van-radio slot="right-icon" :name='item.pc_id' />
                    </van-cell>
                    <van-cell v-show="!pumpList.length>0 ?true:false ">暂无水泵</van-cell>
                </van-cell-group>
            </van-radio-group>
        </van-popup>
        <!-- 选择施肥泵 -->
         <van-popup v-model="showUpChangeFerti"  get-container="body" :style="{ width: '150px'}">
            <van-radio-group v-model="upRotaInfo.fertilizer.key">
                <van-cell-group>
                    <van-cell v-show="fertilizerList.length>0 ?true:false " v-for="(item,index) in fertilizerList" :key='index' :title="item.name" clickable @click="changeUpFerti(item)">
                        <van-radio slot="right-icon" :name='item.pc_id' />
                    </van-cell>
                    <van-cell v-show="!fertilizerList.length>0 ?true:false ">暂无施肥泵</van-cell>
                </van-cell-group>
            </van-radio-group>
        </van-popup>
        <!-- 选择阀门 -->
         <van-popup v-model="showUpChangeValve"   get-container="body" :style="{ width: '80%',height:'80%'}">
             <van-sticky :offset-top="0" >
            <van-cell title=" " v-show='valveArr.length>0 ? true :false'>
                <van-icon slot="icon" size='16px' name="cross" style="line-height: inherit;" @click='showUpChangeValve = false;transitList = []' />
                <van-icon slot="right-icon" size='16px' name="success" style="line-height: inherit;" @click='saveUpValveList' />
            </van-cell>
             </van-sticky>
             <div style="position:absolute;top:40px;bottom:0;overflow:auto;width:100%">
                <van-checkbox-group v-model="transitList"  >                                
                    <van-cell-group>
                        <van-cell v-show='valveArr.length>0 ? true :false' v-for="(item, index) in valveArr" clickable :key="index" :title="item.name" @click="upValveToggle(index)">
                            <van-checkbox :name="item.pc_id" ref="upValveCheckboxes" slot="right-icon" />
                        </van-cell>
                        <van-cell v-show='!valveArr.length>0 ? true :false'>暂无阀门</van-cell>
                    </van-cell-group>
                </van-checkbox-group>
             </div>            
        </van-popup>


    </div>
</template>

<script>
import {getRotationList,getNodeValvePoint,addWebRotation} from '@/request/data'
export default {
    props:{
        uuid:{
            type:[String,Number],
            required: true
        },
        baseName:{
            type:String,
        }
    },
    data() {
        return {
            clientHeight:'',
            rotationList:[],
            valveList:[],
            valveArr:[],
            pumpList:[],
            fertilizerList:[],
            choiceValverList:[],
            addRotaInfo:{
                name:'',
                Interval:'',
                Duration:'',
                WeekPlan:[],
                reploopList:[],
                loopState:0,               
                Repeate:0,
                StartTime:'',
                valid:'0',
                pump:{
                    key:'',
                    name:''
                },
                fertilizer:{
                    key:'',
                    name:''
                },
                rotationList:[]
            },
            transitList:[],
            valveNameList:[],
            showWeekPlan:false,
            showloopState:false,
            showStartTime:false,
            showvalid:false,
            showChangePump:false,
            showChangeFerti:false,
            showChangeValve:false,
            addActiveNames:['1'],
            upActiveNames:['1'],
            upRotaInfo:{
                id:Number,
                name:'',
                Interval:'',
                Duration:'',
                WeekPlan:[],
                reploopList:[],
                loopState:0,               
                Repeate:0,
                StartTime:'',
                valid:'0',
                pump:{
                    key:'',
                    name:''
                },
                fertilizer:{
                    key:'',
                    name:''
                },
                rotationList:[]
            },
            secondArr:[],
            openLoadList:[],
            upValveNameList:[],
            showUpWeekPlan:false,
            showUploopState:false,
            showUpStartTime:false,
            showUpvalid:false,
            showUpChangePump:false,
            showUpChangeFerti:false,
            showUpChangeValve:false,
            weekList:[
                {"key":'MON',value:'周一'},
                {"key":'TUE',value:'周二'},
                {"key":'WED',value:'周三'},
                {"key":'THU',value:'周四'},
                {"key":'FRI',value:'周五'},
                {"key":'SAT',value:'周六'},
                {"key":'SUN',value:'周日'},
            ],
            stateList:[{"key":'loop',value:'循环'},{"key":'repeat',value:'重复'}],                     
            validList:[{"key":'打开',value:'自动功能打开'},{"key":'关闭',value:'自动功能关闭'}],            
            isShowaddRotationPopup:false,
            isShowupRotationPopup:false,
            isShowchangWeekPlan:false,           
        }
    },
    mounted() {
        this.clientHeight =   `${document.documentElement.clientHeight}`
        window.onresize = function temp() {
            this.clientHeight = `${document.documentElement.clientHeight}`;
        };
        this.getRotationList()
        this.getValveList()
    },
    watch: {
        clientHeight: function () {
            this.changeFixed(this.clientHeight)
        },
        "$store.state.websocket.msg":{
            handler(newVal,oldVal){
                console.log('轮灌组页面监听到服务器回应:'+ 'newVal:' + newVal + ',oldVal' + oldVal)
                this.addRotationMessage()
                this.delMessage()
                this.openCloseMessage()
            },
            immidiate:true,
            deep:true,
        }
    },
    methods: {
        getValveList(){
            let data ={}
            data.uuid = this.uuid
            // data.token = this.token
            getNodeValvePoint(data).then(res=>{                
                if (res.data.code ==0 && res.data.hasOwnProperty('data')) {
                    this.valveList = res.data.data
                    // this.addRotaInfo.pump = []
                    this.valveArr = []
                    this.pumpList = []
                    this.fertilizerList = []
                for (let i = 0; i < this.valveList.length; i++) {
                    if (this.valveList[i].type == 0) {
                        this.valveArr.push(this.valveList[i])
                    }
                    if (this.valveList[i].type == 1) {
                        this.pumpList.push(this.valveList[i])
                    }
                    if (this.valveList[i].type == 2) {
                        this.fertilizerList.push(this.valveList[i])
                    }
                }
                }
                })
        },
        getRotationList(){
            let data = {}
            // data.token = this.token
            data.uuid = this.uuid
            getRotationList(data).then(res=>{               
                if (res.data.code == 0 && res.data.hasOwnProperty('data')) {
                    if (res.data.data.length > 0) {
                        
                        for (let i = 0; i < res.data.data.length; i++) {
                          res.data.data[i].loadState = 0                            
                        }
                        this.rotationList = res.data.data
                        console.log(this.rotationList)
                    }else{
                        // AlertModule.show({
                        //     title: '暂无轮灌组',
                        // })
                    }
                }else{
                    // AlertModule.show({
                    //     title: '暂无轮灌组',
                    // })
                }
            })
        },
        addRotationPopup(){//新增页面出现
            this.addRotaInfo.name = ''
            this.addRotaInfo.Interval = ''
            this.addRotaInfo.Duration = ''
            this.addRotaInfo.WeekPlan = []
            this.addRotaInfo.loopState = ''
            this.addRotaInfo.Repeate = ''
            this.addRotaInfo.StartTime = ''
            this.addRotaInfo.valid = '0'
            this.addRotaInfo.pump.key = ''
            this.addRotaInfo.pump.name = ''
            this.addRotaInfo.fertilizer.key = ''
            this.addRotaInfo.fertilizer.name = ''
            this.addRotaInfo.rotationList = []
            this.valveNameList = []            
            this.isShowaddRotationPopup = true
        },
        changeAddPump(item){
            this.addRotaInfo.pump.key = item.pc_id
            this.addRotaInfo.pump.name = item.name
            this.showChangePump=false
        },
        changeAddFerti(item){            
            this.addRotaInfo.fertilizer.key = item.pc_id
            this.addRotaInfo.fertilizer.name = item.name
            this.showChangeFerti=false
        },
        
        saveValveList(){//保存轮灌小组
            this.addRotaInfo.rotationList.push(this.transitList)
            
            let data = []
            for (let i = 0; i < this.transitList.length; i++) {
                for (let j = 0; j < this.valveArr.length; j++) {
                    // console.log(this.transitList[i],this.valveArr[j].pc_id)
                    if (this.transitList[i] == this.valveArr[j].pc_id) {
                         data.push(this.valveArr[j].name)
                    }                    
                }                
            }
            this.valveNameList.push(data)            
            this.showChangeValve = false
            this.transitList = []
            console.log(this.addRotaInfo.rotationList)
        },
        addDelValveList(index){//删除轮灌小组
            this.addRotaInfo.rotationList.splice(index, 1)
            this.valveNameList.splice(index, 1)
        },
        addNewRotation(){//提交新增
            //时间
            let time = new Date();
            let reg= new RegExp('/','g');
            let nowTime = time.toLocaleDateString().replace(reg, "-")

            if (this.addRotaInfo.reploopList) {
                for (let i = 0; i < this.addRotaInfo.reploopList.length; i++) {
                    if (this.addRotaInfo.reploopList[i] == 'loop') {
                            this.addRotaInfo.loopState = 1
                    }else{
                        this.addRotaInfo.loopState = 0
                    }
                    if (this.addRotaInfo.reploopList[i] == 'repeat') {
                        this.addRotaInfo.Repeate = 1
                    }else{
                        this.addRotaInfo.Repeate = 0
                    }                    
                }
            }else{
                this.addRotaInfo.Repeate = 0
                this.addRotaInfo.loopState = 0
            }

            this.addRotaInfo.rotationList[0].unshift(this.addRotaInfo.pump.key)
            let newArr =  this.addRotaInfo.rotationList.join(';')
            if (this.nodeType == 1) {
                let websockData = {
                    magic      : 11,
                    action     : 0,
                    id         : 0,
                    Uuid       : this.uuid + '',
                    name       : this.addRotaInfo.name + '',
                    StartTime  : nowTime +' '+ this.addRotaInfo.StartTime,
                    valid      : parseInt(this.addRotaInfo.valid),
                    Interval   : parseFloat(this.addRotaInfo.Interval),
                    Duration   : parseFloat(this.addRotaInfo.Duration),
                    WeekPlan   : this.addRotaInfo.WeekPlan.toString(),
                    Repeate    : this.addRotaInfo.Repeate,
                    loopState  : this.addRotaInfo.loopState,
                    cropNum    : 0,
                    IrrigateId : newArr,
                    token      : this.$store.state.token
                };
                console.log(websockData)
                this.$store.state.websocket.ws.send(websockData)
                
            }else if(this.nodeType == 2){
                let websockData = {
                    action     : 0,
                    Uuid       : this.uuid + '',
                    web_id     : 0,
                    name       : this.addRotaInfo.name + '',
                    StartTime  : nowTime +' '+ this.addRotaInfo.StartTime,
                    Interval   : parseFloat(this.addRotaInfo.Interval),
                    Duration   : parseFloat(this.addRotaInfo.Duration),
                    WeekPlan   : this.addRotaInfo.WeekPlan.toString(),
                    Repeate    : this.addRotaInfo.Repeate,
                    loopState  : this.addRotaInfo.loopState,
                    IrrigateId : newArr,
                    valid      : parseInt(this.addRotaInfo.valid)                    
                };
                addWebRotation(websockData).then(res=>{
                    this.$toast.clear()
                    this.$toast.success('新增成功')
                    console.log(res)
                }).catch()
            }
            this.$toast.loading({
                message:'新增中',
                duration: 0
            });
                
        },
        addRotationMessage(){
            console.log('轮灌组新增/修改处理websocket回应')
            let data = JSON.parse(this.$store.state.websocket.msg);
             //返回值只对当前控制器生效            
            if(data.magic == 12 && this.uuid == data.uuid){
                    console.log(data)
                    if (data.state == 0) {
                        this.$toast.clear()
                        if (data.action == 0 ) {
                            this.isShowaddRotationPopup = false
                            this.$toast.success('新增成功')
                        }else{
                            this.isShowupRotationPopup = false
                            this.$toast.success('修改成功')
                            
                        }
                        this.getRotationList()
                    } else {
                        this.$toast.clear()
                        if (data.action == 0 ) {
                           this.$toast.fail('新增失败')
                        }else{
                           this.$toast.fail('修改失败')
                        }
                        // this.getRotationList()
                    }
                    
            }
        },
        upRotationPopup(item,index){//修改页面出现
            console.log(item)
            this.isShowupRotationPopup = true
            this.upRotaInfo.name = item.name
            this.upRotaInfo.id = item.pc_id
            this.upRotaInfo.Interval = item.group_interval
            this.upRotaInfo.Duration = item.duration
            this.upRotaInfo.WeekPlan = item.week_plan.split(",")                    
            this.upRotaInfo.reploopList = []
            if (item.repeate) {
                this.upRotaInfo.reploopList.push('repeat')
            }
            if (item.loop_state) {
                this.upRotaInfo.reploopList.push('loop')
            }

            this.upRotaInfo.StartTime = item.start_time.substring(11,16)
            this.upRotaInfo.valid = item.valid.toString()
            this.upRotaInfo.pump.key = parseInt(item.group_pump)  
            for (let i = 0; i < this.pumpList.length; i++) {
               if (this.pumpList[i].pc_id == item.group_pump) {
                   this.upRotaInfo.pump.name = this.pumpList[i].name
               }
                
            }            
            this.upRotaInfo.rotationList = []
            this.upRotaInfo.rotationList = [...item.group]
            this.upValveNameList = []
            for (let i = 0; i < item.group.length; i++) {
                let data = []
                for (let j = 0; j < item.group[i].length; j++) {
                    for (let x = 0; x < this.valveArr.length; x++) {
                        if (item.group[i][j] == this.valveArr[x].pc_id) {
                            data.push(this.valveArr[x].name)
                        }
                    }
                }                
                this.upValveNameList.push(data)
            }
            // this.upRotaInfo.reploopList = 
        },
        upDelValveList(index){//更新页面中-删除轮灌小组
            this.upRotaInfo.rotationList.splice(index, 1)
            this.upValveNameList.splice(index, 1)
        },
        saveUpValveList(){//保存轮灌小组
            this.upRotaInfo.rotationList.push(this.transitList)            
            let data = []
            for (let i = 0; i < this.transitList.length; i++) {
                for (let j = 0; j < this.valveArr.length; j++) {
                    // console.log(this.transitList[i],this.valveArr[j].pc_id)
                    if (this.transitList[i] == this.valveArr[j].pc_id) {
                         data.push(this.valveArr[j].name)
                    }                    
                }                
            }
            this.upValveNameList.push(data)            
            this.showUpChangeValve = false
            this.transitList = []            
        },
        changeUpPump(item){
            this.upRotaInfo.pump.key = item.pc_id
            this.upRotaInfo.pump.name = item.name
            this.showUpChangePump=false
        },
        upRotation(){
            //时间
            let time = new Date();
            let reg= new RegExp('/','g');
            let nowTime = time.toLocaleDateString().replace(reg, "-")

            if (this.upRotaInfo.reploopList) {
                for (let i = 0; i < this.upRotaInfo.reploopList.length; i++) {
                    if (this.upRotaInfo.reploopList[i] == 'loop') {
                            this.upRotaInfo.loopState = 1
                    }else{
                        this.upRotaInfo.loopState = 0
                    }
                    if (this.upRotaInfo.reploopList[i] == 'repeat') {
                        this.addRotaInfo.Repeate = 1
                    }else{
                        this.upRotaInfo.Repeate = 0
                    }                    
                }
            }else{
                this.upRotaInfo.Repeate = 0
                this.upRotaInfo.loopState = 0
            }

            this.upRotaInfo.rotationList[0].unshift(this.upRotaInfo.pump.key)
            let newArr =  this.upRotaInfo.rotationList.join(';')
            if (this.nodeType ==1) {
                let websockData = {
                    magic      : 11,
                    action     : 1,
                    id         : this.upRotaInfo.pc_id,
                    Uuid       : this.uuid + '',
                    name       : this.upRotaInfo.name + '',
                    StartTime  : nowTime +' '+ this.upRotaInfo.StartTime,
                    valid      : parseInt(this.upRotaInfo.valid),
                    Interval   : parseFloat(this.upRotaInfo.Interval),
                    Duration   : parseFloat(this.upRotaInfo.Duration),
                    WeekPlan   : this.upRotaInfo.WeekPlan.toString(),
                    Repeate    : this.upRotaInfo.Repeate,
                    loopState  : this.upRotaInfo.loopState,
                    cropNum    : 0,
                    IrrigateId : newArr,
                    token      : this.$store.state.token
                };
                console.log(websockData)
                this.$store.state.websocket.ws.send(websockData)
                
            }else if(this.nodeType ==2){
                let websockData = {                    
                    action     : 1,
                    Uuid       : this.uuid + '',
                    web_id     : this.upRotaInfo.id,
                    name       : this.upRotaInfo.name + '',
                    StartTime  : nowTime +' '+ this.upRotaInfo.StartTime,
                    Interval   : parseFloat(this.upRotaInfo.Interval),
                    Duration   : parseFloat(this.upRotaInfo.Duration),
                    WeekPlan   : this.upRotaInfo.WeekPlan.toString(),
                    Repeate    : this.upRotaInfo.Repeate,
                    loopState  : this.upRotaInfo.loopState,
                    IrrigateId : newArr,
                    valid      : parseInt(this.upRotaInfo.valid),                    
                };
                addWebRotation(websockData).then(res=>{
                     this.$toast.clear()
                    this.$toast.success('修改成功')
                    console.log(res)
                })
            }
            
            this.$toast.loading({
                message:'修改中',
                duration: 0
            });
        },
        openCloseRotation(item,index){
            let state = item.run_state ? 0 : 1
            console.log(state,item.run_state)
            let websockData = {
                magic      : 128,
                orderId    : state,
                taskId     : item.pc_id,
                pcUuid     : this.uuid + '',
                remoteUuid : this.$store.state.userUuid + '',
                token      : this.$store.state.token                
            }
            console.log(websockData)
            this.$store.state.websocket.ws.send(websockData)
            this.countDown(index,state)


        },
        countDown(i,orderId){//倒计时
            let _that = this
            let second = 10    
            let setIn = setInterval(() => {
                if (second ==0) {
                    this.rotationList[i].loadState = 0                
                    _that.$toast.fail('超时,请以实际情况为准')
                    _that.getRotationList()
                    window.clearInterval(this.openLoadList[i])
                }else{
                    _that.rotationList[i].loadState = 1
                    second--
                    _that.secondArr[i] = second
                
                }
            }, 1000);
            this.openLoadList[i] = setIn
        },
        openCloseMessage(){//开关轮灌组处理信息
            console.log('轮灌组开关处理websocket回应')
            let data = JSON.parse(this.$store.state.websocket.msg);
             //返回值只对当前控制器生效
            if(data.magic == 129 && this.uuid == data.pcUuid){
                console.log(data)
                if (data.state == 0) {
                    if (data.orderId == 1) {
                        for (let i = 0; i < this.rotationList.length; i++) {
                            if (this.rotationList[i].pc_id == data.taskId) {
                                window.clearInterval(this.openLoadList[i])
                                this.rotationList[i].run_state = data.orderId
                                this.rotationList[i].loadState = 0
                            }                  
                        }   
                        this.$toast.success('轮灌组开启成功')

                    }else{
                        for (let i = 0; i < this.rotationList.length; i++) {
                            if (this.rotationList[i].pc_id ==data.taskId) {
                                window.clearInterval(this.openLoadList[i])
                                this.rotationList[i].run_state = data.orderId
                                this.rotationList[i].loadState = 0                                             
                            }                  
                        } 
                        this.$toast.success('轮灌组关闭成功')
                    }
                }
            }

        },
        delok(item){//删除轮灌组
            let websockData = {
                magic      : 13,                
                id         : item.pc_id,
                Uuid       : item.uuid + '',
                token      : this.$store.state.token
            };                
            this.$store.state.websocket.ws.send(websockData)
            this.$toast.loading({
                message:'删除中',
                duration: 0
            });
        },
        delMessage(){//删除轮灌组处理信息
            console.log('删除轮灌组接收回复信息开始处理websocket回应')
            let data = JSON.parse(this.$store.state.websocket.msg);
             //返回值只对当前控制器生效            
            if(data.magic == 14 && this.uuid == data.uuid){
                    this.$toast.clear()
                    if (data.state == 0 ) {                       
                       this.$toast.success('删除成功')                    
                    }else{
                        this.$toast.fail('删除失败')
                    }
                    this.getRotationList()
            }

        },
        weekPlanChang(){            
            this.isShowchangWeekPlan = true
        },        
        rListShow(){
            this.$emit('rListSon', 2);
        },
        weekToggle(index){
            this.$refs.weekCheckboxes[index].toggle();            
        },
        upweekToggle(index){
            this.$refs.upWeekCheckboxes[index].toggle();            
        },
        valveToggle(index){
            this.$refs.valveCheckboxes[index].toggle(); 
        },
        upValveToggle(index){
            this.$refs.upValveCheckboxes[index].toggle(); 
        },
        stateToggle(index){
            this.$refs.stateCheckboxes[index].toggle();
        },
        upstateToggle(index){
            this.$refs.stateUpCheckboxes[index].toggle();
        },
        changeFixed(clientHeight){//动态修改地图高度样式
            this.$nextTick(() => {
                this.$refs.pageMain.style.height = (clientHeight-134)+'px';
            })
        },
    },

}
</script>

<style scoped>
.van-button--mini{min-width:30px!important}
</style>

